/** @jsxImportSource @emotion/react */
import { Modal } from '@mui/material'
import * as classes from './styles'

export type BaseModalProps = {
  open: boolean
  onClose: () => void
  children: JSX.Element | JSX.Element[]
  className?: string
}

export const BaseModal = ({ open, onClose, children, className }: BaseModalProps) => (
  <Modal open={open} onClose={onClose} className={className}>
    <div css={classes.container} className="container">
      {children}
    </div>
  </Modal>
)
